/**
 * offsetMs = serverTimeSec*1000 - (sentAtMs + receivedAtMs)/2
 * @param {number} sentAtMs
 * @param {number} receivedAtMs
 * @param {number} serverTimeSec
 * @returns {number}
 */
export function computeOffsetMs(sentAtMs, receivedAtMs, serverTimeSec) {
    return serverTimeSec * 1000 - (sentAtMs + receivedAtMs) / 2;
}

/**
 * @param {number} expiresAtMs
 * @param {number} clientNowMs
 * @param {number} offsetMs
 * @returns {number}
 */
export function remainingMs(expiresAtMs, clientNowMs, offsetMs) {
    const correctedNowMs = clientNowMs + offsetMs;
    return Math.max(0, expiresAtMs - correctedNowMs);
}

/**
 * @param {number} expiresAtMs
 * @param {number} clientNowMs
 * @param {number} offsetMs
 * @returns {number}
 */
export function remainingSeconds(expiresAtMs, clientNowMs, offsetMs) {
    return Math.floor(remainingMs(expiresAtMs, clientNowMs, offsetMs) / 1000);
}

/**
 * @returns {{ offsetMs: number, sync: function, now: function, remainingSeconds: function }}
 */
export function createClock() {
    const state = { offsetMs: 0 };

    return {
        get offsetMs() {
            return state.offsetMs;
        },
        sync(sentAtMs, receivedAtMs, serverTimeSec) {
            state.offsetMs = computeOffsetMs(sentAtMs, receivedAtMs, serverTimeSec);
        },
        now(clientNowMs) {
            return clientNowMs + state.offsetMs;
        },
        remainingSeconds(expiresAtMs, clientNowMs) {
            return remainingSeconds(expiresAtMs, clientNowMs, state.offsetMs);
        },
    };
}
